import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import { ReactComponent as LinkSvg } from "../../../assets/link.svg";
import { Button, Form, Label } from "semantic-ui-react";
import { Formik, ErrorMessage } from "formik";
import { ReactComponent as ThumbsUpSvg } from "../../../assets/navbericon/thumbsup.svg";
import { ReactComponent as InfoDotGreenSvg } from "../../../assets/infodotgreen.svg";
import { ReactComponent as GreenDropDownIcon } from "../../../assets/greendropdown.svg";
import { ReactComponent as EditButtonSvg } from "../../../assets/useredit.svg";
import { ReactComponent as UploadHeaderSvg } from "../../../assets/UploadHeader.svg";
import { ReactComponent as UploadLogoSvg } from "../../../assets/UploadLogo.svg";
import Modal from "../../../app/common/modals/Custom";
import { toast } from 'react-toastify';
import { InputTemp, SelectTemp, VendorInputTemp, } from "../../../app/common/form/Custom";
import { vendorSchema } from "../../../app/validation/validationSchema";
import { useStore } from "../../../app/stores/store";
import Loading from "../../../app/layout/Loading";
import { observer } from "mobx-react-lite";
import { AccountInformation } from "../../../app/models/user";
import responseCodes from "../../../app/common/hooks/helpers";
import MyTextArea from "../../../app/common/form/MyTextArea";
import { Checkbox, FormControlLabel, Radio,
  RadioGroup, } from "@mui/material";
import { resolveImageSrc } from "../../../utils/ConvertImage";

const SettingsIndex = () => {
  const [modal, setModal] = useState("");
  const [activeOption, setActiveOption] = useState("personal");
  const [headerImageUpload, setHeaderImageUpload] = useState<string>("");
  const [logoImageUpload, setLogoImageUpload] = useState<string>("");
  const [personalIsEdit, setPersonalIsEdit] = useState(false);
  const [storeIsEdit, setStoreIsEdit] = useState(false);
  const headerImageRef = useRef<HTMLInputElement>(null);
  const logoImageRef = useRef<HTMLInputElement>(null);
  const { userStore } = useStore();
  const {
    accountInformation,
    userStates,
    getAccountInfo,
    getStates,
    updateVendor,
    status,
  } = userStore;

  const [mailNotification, setMailNotification] = useState(false);

  const [appNotification, setAppNotification] =  useState(false);

  const UPLOAD_LIMIT = Number(process.env.REACT_APP_UPLOAD_LIMIT);

  const headerImageHandler = (e: any) => {
    // console.log(e);
    try {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      if (file.size > UPLOAD_LIMIT) {
        toast.error('File too large. Maximum upload size is 1 MB.');
        setHeaderImageUpload("");
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          setHeaderImageUpload(reader.result!.toString());
        }
      };
      reader.readAsDataURL(file);
    } catch {
      // console.log("none");
      setHeaderImageUpload("");
    }
  };

  const logoImageHandler = (e: any) => {
    // console.log(e);
    try {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      if (file.size > UPLOAD_LIMIT) {
        toast.error('File too large. Maximum upload size is 1 MB.');
        setLogoImageUpload("");
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          setLogoImageUpload(reader.result!.toString());
        }
      };
      reader.readAsDataURL(file);
    } catch {
      // console.log("none");
      setLogoImageUpload("");
    }
  };
  // console.log(logoImageUpload, headerImageUpload);
  const saveForm = (values: AccountInformation) => {
    const payload = {
      headerImageUrl: !headerImageUpload ? "" : headerImageUpload,
      logoImageUrl: !logoImageUpload ? "" : logoImageUpload,
      storeAddress: values.storeAddress
        ? values.storeAddress
        : accountInformation.storeAddress,
      storeInformation: values.storeInformation
        ? values.storeInformation
        : accountInformation.storeInformation,
      state: values.state ? values.state : accountInformation.state,
      city: values.city ? values.city : accountInformation.city,
      storeName: values.storeName ? values.storeName : "",
      // password: "!Test123",
      password: values.password ? values.password : "",
      firstName: values.firstName
        ? values.firstName
        : accountInformation.firstName,
      lastName: values.lastName ? values.lastName : accountInformation.lastName,
      phoneNumber: values.phoneNumber
        ? values.phoneNumber
        : accountInformation.phoneNumber,
      slug: accountInformation.slug ? accountInformation.slug : "",
      appNotificationFlag : values.appNotificationFlag,
      mailNotificationFlag :values.mailNotificationFlag
    };
    // console.log(payload);
    updateVendor(payload).then((res) => {
      if (res.responseCode === responseCodes.response_00) {
        setStoreIsEdit(false)
        // console.log(res.data);
      }
    });
  };
  const initialValues = {
    vendorId: accountInformation.vendorId,
    role: 2,
    state: accountInformation.state ? accountInformation.state : "",
    city: accountInformation.city ? accountInformation.city : "",
    headerImageUrl: null,
    storeAddress: accountInformation.storeAddress
      ? accountInformation.storeAddress
      : "",
    businessName: accountInformation.businessName
      ? accountInformation.businessName
      : "",
    storeName: accountInformation.storeName ? accountInformation.storeName : "",
    storeLogoUrl: null,
    firstName: accountInformation.firstName ? accountInformation.firstName : "",
    lastName: accountInformation.lastName ? accountInformation.lastName : "",
    email: accountInformation.email ? accountInformation.email : "",
    gender: null,
    address: null,
    phoneNumber: accountInformation.phoneNumber
      ? accountInformation.phoneNumber
      : "",
    password: accountInformation.password ? accountInformation.password : "",
    isEmailVerified: true,
    sellingPermission: true,
    status: null,
    isProfileCompleted: false,
    isActive: null,
    isSuspended: false,
    rating: null,
    slug: accountInformation.slug ? accountInformation.slug : "",
    storeUrl: accountInformation.storeUrl ? accountInformation.storeUrl : "",
    storeLGA: null,
    storeState: accountInformation.storeState
      ? accountInformation.storeState
      : "",
    bankAccountName: null,
    bankAccountNumber: null,
    storeInformation: accountInformation.storeInformation
      ? accountInformation.storeInformation
      : "",
    
      appNotificationFlag : accountInformation.appNotificationFlag
      ? accountInformation.appNotificationFlag
      : false,

      mailNotificationFlag :accountInformation.mailNotificationFlag
      ? accountInformation.mailNotificationFlag
      : false,
  };

  // console.log(initialValues);
  useEffect(() => {
    getStates().then(() =>
      getAccountInfo().then((res) => {
        // console.log(res)
        if (!res.isSuccessful) {
        }
      })
    );
  }, [getAccountInfo, getStates]);

  const resolvedHeaderImageUrl = resolveImageSrc(accountInformation.headerImageUrl);
  const resolvedStoreLogoUrl = resolveImageSrc(accountInformation.storeLogoUrl);

  return (
    <div className={styles.page}>
      {status === "loading" && <Loading />}
      {modal && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setModal("1")}
        >
          <div className={styles.verifyAccountModal}>
            {/* <h2>Activate Selling Permission</h2> */}

            <div className={styles.info}>
              {" "}
              <ThumbsUpSvg />
            </div>
            <div className={styles.welcomeText}>
              <p>Add John Doe?</p>
            </div>

            <div className={styles.twoButton}>
              <Button
                // positive
                className={styles.negative}
                onClick={() => setModal("")}
              >
                <div className={styles.button}>
                  <span>Cancel</span>
                </div>
              </Button>
              <Button
                positive
                className={styles.modalactivate}
                onClick={() => setModal("1")}
              >
                <div className={styles.button}>
                  <span>Yes, I want to!</span>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}

      <div className={styles.back}>
        <span>Settings</span>
      </div>
      <div className={styles.header}>
        {" "}
        <div className={styles.storeVisibility}>
          <h4>Store Visibility</h4>
          <Button
            positive
            className={styles.userStatus}
            // onClick={() => navigate("/vendor/new-product")}
          >
            <InfoDotGreenSvg />
            <div className={styles.positive}>
              <span>Online</span>
              {/* <PlusCircle /> */}
            </div>
            <GreenDropDownIcon />
          </Button>
        </div>
        {process.env.REACT_APP_API_URL &&
          accountInformation.slug &&
          accountInformation.isActive && (
            <div className={styles.storeUrl}>
              <h4>Store url:</h4>
              <h5
                className={styles.url}
              >{`${window.location.origin}/vendors/${accountInformation.slug}`}</h5>
              <LinkSvg
                onClick={() =>
                  window.open(
                    `${window.location.origin}/vendors/${accountInformation.slug}`,
                    "_blank"
                  )
                }
              />
            </div>
          )}
      </div>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={saveForm}
        validationSchema={
          activeOption === "store"
            ? vendorSchema.storeSettings
            : vendorSchema.personalSettings
        }
      >
        {({
          dirty,
          getFieldProps,
          handleSubmit,
          values,
          setFieldValue,
          isValid,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div className={styles.form}>
                <div className={styles.settingsOptions}>
                  <div
                    className={`${styles.personalOption} ${
                      activeOption === "personal" && styles.active
                    }`}
                    onClick={() => setActiveOption("personal")}
                  >
                    <h4>Personal Settings</h4>
                  </div>
                  <div
                    className={`${styles.storeOption} ${
                      activeOption === "store" && styles.active
                    }`}
                    onClick={() => setActiveOption("store")}
                  >
                    <h4>Store Settings</h4>
                  </div>
                </div>
                {activeOption === "personal" && (
                  <div className={styles.column2}>
                    <div
                      className={styles.edit}
                      onClick={() => setPersonalIsEdit(!personalIsEdit)}
                    >
                      <div
                        className={`${styles.editButton}  ${
                          personalIsEdit && styles.active
                        }`}
                      >
                        <span>Edit</span>
                        <span>
                          <EditButtonSvg />
                        </span>
                      </div>
                    </div>
                    <div className={styles.flexForm}>
                      <div className={styles.marginRight}>
                        <InputTemp
                          inputType="text"
                          label={"First Name"}
                          // placeholder={
                          //   product && productId !== "new"
                          //     ? product.description
                          //     : "Enter Description"
                          // }
                          marginRight
                          disabled
                          value={values.firstName!}
                        />
                      </div>
                      <div className={styles.marginLeft}>
                        <InputTemp
                          inputType="text"
                          label={"Last Name"}
                          // placeholder={
                          //   product && productId !== "new"
                          //     ? product.description
                          //     : "Enter Description"
                          // }
                          marginRight
                          disabled
                          value={values.lastName!}
                        />
                      </div>
                      <div className={styles.marginLeft}>
                        <InputTemp
                          inputType="text"
                          label={"Password"}
                          placeholder={"*************"}
                          marginRight
                          disabled={!personalIsEdit}
                          {...getFieldProps("password")}
                        />
                        <ErrorMessage
                          name={"password"}
                          render={(error) => (
                            <Label basic color="red" content={error} />
                          )}
                        />
                      </div>
                    </div>
                    <div className={styles.flexForm}>
                      <div className={styles.marginRight}>
                        <InputTemp
                          inputType="text"
                          label={"Email"}
                          // placeholder={
                          //   product && productId !== "new"
                          //     ? product.description
                          //     : "Enter Description"
                          // }
                          disabled
                          marginRight
                          {...getFieldProps("email")}
                        />
                        <ErrorMessage
                          name={"email"}
                          render={(error) => (
                            <Label basic color="red" content={error} />
                          )}
                        />
                      </div>
                      <div className={styles.marginLeft}>
                        <InputTemp
                          inputType="text"
                          label={"Phone Number"}
                          // placeholder={
                          //   product && productId !== "new"
                          //     ? product.description
                          //     : "Enter Description"
                          // }
                          marginRight
                          disabled
                          {...getFieldProps("phoneNumber")}
                        />
                        <ErrorMessage
                          name={"phoneNumber"}
                          render={(error) => (
                            <Label basic color="red" content={error} />
                          )}
                        />
                      </div>
                      <div></div>
                    </div>
                  </div>
                )}
                {activeOption === "store" && (
                  <div className={styles.column2}>
                    <div
                      className={styles.edit}
                      onClick={() => setStoreIsEdit(!storeIsEdit)}
                    >
                      <div
                        className={`${styles.editButton}  ${
                          storeIsEdit && styles.active
                        }`}
                      >
                        <span>Edit</span>
                        <span>
                          <EditButtonSvg />
                        </span>
                      </div>
                    </div>
                    <div className={styles.uploadSection}>
                      <div className={styles.headerImageUpload}>
                        <div className={styles.headerUploadBox}>
                          {(headerImageUpload || resolvedHeaderImageUrl) && (
                            <img
                              src={
                                headerImageUpload
                                  ? `${headerImageUpload}`
                                  : resolvedHeaderImageUrl
                              }
                              alt={""}
                              onError={(e) => {
                                (e.target as HTMLImageElement).style.display = "none";
                              }}
                            />
                          )}
                          {!resolvedHeaderImageUrl &&
                            !headerImageUpload &&
                            !storeIsEdit && (
                              <div className={styles.loadedtext}>
                                No Image found
                              </div>
                            )}
                          <input
                            hidden
                            ref={headerImageRef}
                            type="file"
                            accept="image/*"
                            onChange={headerImageHandler}
                          />
                          {storeIsEdit && (
                            <div
                              onClick={() =>
                                headerImageRef.current &&
                                headerImageRef.current.click()
                              }
                            >
                              {!headerImageUpload && <UploadHeaderSvg />}
                              {/* <UploadHeaderSvg /> */}
                              <div
                                className={
                                  !headerImageUpload
                                    ? styles.uploadtext
                                    : styles.uploadedtext
                                }
                              >
                                Upload Header Image
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className={styles.logoupload}>
                        {(logoImageUpload || resolvedStoreLogoUrl) && (
                          <img
                            src={
                              logoImageUpload
                                ? `${logoImageUpload}`
                                : resolvedStoreLogoUrl
                            }
                            alt={""}
                            onError={(e) => {
                              (e.target as HTMLImageElement).style.display = "none";
                            }}
                          />
                        )}
                        {!resolvedStoreLogoUrl && !logoImageUpload && !storeIsEdit && (
                          <div className={styles.logoloadedtext}>
                            No Image found
                          </div>
                        )}
                        <input
                          hidden
                          ref={logoImageRef}
                          type="file"
                          accept="image/*"
                          onChange={logoImageHandler}
                        />
                        {storeIsEdit && (
                          <div
                            onClick={() =>
                              logoImageRef.current &&
                              logoImageRef.current.click()
                            }
                          >
                            {!logoImageUpload && <UploadLogoSvg />}
                            {/* <UploadLogoSvg /> */}
                            <div
                              className={
                                !logoImageUpload
                                  ? styles.uploadtext
                                  : styles.uploadedtext
                              }
                            >
                              Upload Logo
                            </div>
                          </div>
                        )}
                      </div>
                      <div className={styles.businessName}>
                        {accountInformation.businessName}
                      </div>
                    </div>
                    <div className={`${styles.flexForm} ${styles.minimargin}`}>
                      <div className={styles.marginRight}>
                        <InputTemp
                          inputType="text"
                          label={"Store Address"}
                          // placeholder={
                          //   product && productId !== "new"
                          //     ? product.description
                          //     : "Enter Description"
                          // }
                          disabled={!storeIsEdit}
                          marginRight
                          {...getFieldProps("storeAddress")}
                        />
                        <ErrorMessage
                          name={"storeAddress"}
                          render={(error) => (
                            <Label basic color="red" content={error} />
                          )}
                        />
                        <div className={styles.flexForm}>
                          <div className={styles.marginRight}>
                            <SelectTemp
                              inputType="text"
                              labelStyle={{
                                fontFamily: "Montserrat",
                                color: "#828282",
                                fontWeight: "400" 
                              }}
                              label="State"
                              placeholder={values.state}
                              options={[...userStates]
                                .sort(function (x, y) {
                                  let a = x.state.toUpperCase(),
                                    b = y.state.toUpperCase();
                                  return a === b ? 0 : a > b ? 1 : -1;
                                })
                                .map((category, index) => ({
                                  key: String(index),
                                  label: category.state,
                                  value: category.state,
                                }))}
                              disabled={!storeIsEdit}
                              value={values.state}
                              onValueChange={(e: any) => {
                                setFieldValue("state", e.value);
                              }}
                              name="state"
                            />
                            <ErrorMessage
                              name={"state"}
                              render={(error) => (
                                <Label basic color="red" content={error} />
                              )}
                            />
                          </div>
                          <div className={styles.marginLeft}>
                            {" "}
                            <InputTemp
                              inputType="text"
                              label={"City"}
                              // placeholder={
                              //   product && productId !== "new"
                              //     ? product.description
                              //     : "Enter Description"
                              // }
                              disabled={!storeIsEdit}
                              marginRight
                              {...getFieldProps("city")}
                            />
                            <ErrorMessage
                              name={"city"}
                              render={(error) => (
                                <Label basic color="red" content={error} />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <div className={styles.marginLeft}>
                        <label htmlFor="">
                          Tell us more about your Store
                          <span className="required">*</span>
                        </label>
                        <MyTextArea
                          rows={6}
                          placeholder="..."
                          name="storeInformation"
                          disabled={!storeIsEdit}
                          // {...getFieldProps("storeInformation")}
                        />
                        {/* <ErrorMessage
                          name={"storeInformation"}
                          render={(error) => (
                            <Label basic color="red" content={error} />
                          )}
                        /> */}
                      </div>
                    </div>
                    <div className={`${styles.flexForm} ${styles.minimargin}`}>
                        <FormControlLabel
                          disabled={!storeIsEdit}
                          control={<Checkbox checked={values.mailNotificationFlag} />}
                          label="Enable Product Approval Notifications Via Email"
                          style={{ padding: 0, marginRight: 50 }}
                          onClick={(e) => {
                          if (storeIsEdit) {  // Check if the edit flag is true before setting the value
                                      setFieldValue("mailNotificationFlag", !values.mailNotificationFlag);
                                      setMailNotification(!values.mailNotificationFlag);
                                }
                          }}
                          />
                      </div>

                      <div className={`${styles.flexForm} ${styles.minimargin}`}>
                        <FormControlLabel
                          disabled={!storeIsEdit}
                          control={<Checkbox checked={values.appNotificationFlag} />}
                          label="Enable Product Approval Notifications Inside Application"
                          style={{ padding: 0, marginRight: 50 }}
                          onClick={(e) => {
                          if(storeIsEdit){
                            setFieldValue("appNotificationFlag", !values.appNotificationFlag);
                            setAppNotification(!values.appNotificationFlag);
                          }
                          }}
                          />
                      </div>
                  </div>
                )}
              </div>
              <div className={styles.footer}>
                <div className={styles.searchAndFilter}>
                  {activeOption === "personal" && (
                    <Button
                      positive
                      className={styles.bulkProduct}
                      type="submit"
                      disabled={!isValid || !dirty}
                    >
                      <div className={styles.positive}>
                        <span>Save</span>
                      </div>
                    </Button>
                  )}
                  {activeOption === "store" && (
                    <Button
                      positive
                      className={styles.bulkProduct}
                      type="submit"
                      disabled={
                        !isValid ||
                        !storeIsEdit ||
                        // (!dirty &&
                        //   (!!headerImageUpload || !!logoImageUpload))
                        //   ||
                        (!headerImageUpload &&
                          !resolvedHeaderImageUrl) ||
                        (!logoImageUpload && !resolvedStoreLogoUrl)
                      }
                    >
                      <div className={styles.positive}>
                        <span>Save</span>
                      </div>
                    </Button>
                  )}
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default observer(SettingsIndex);